module.exports = __webpack_public_path__ + "static/media/sqlite_logo.7cc3d432.png";